import t from '../labels/labelling-utils';

export type TennisCategoriesType =
  | 'Mens Singles'
  | 'Womens Singles'
  | 'Mens Doubles'
  | 'Womens Doubles'
  | 'Mixed Doubles';

const mensSingles: TennisCategoriesType = 'Mens Singles';
const womensSingles: TennisCategoriesType = 'Womens Singles';
const mensDoubles: TennisCategoriesType = 'Mens Doubles';
const womensDoubles: TennisCategoriesType = 'Womens Doubles';
const mixedDoubles: TennisCategoriesType = 'Mixed Doubles';

export const categoryMap: {
  [key in TennisCategoriesType]: string;
} = {
  [mensSingles]: t('mens.singles'),
  [womensSingles]: t('womens.singles'),
  [mensDoubles]: t('mens.doubles'),
  [womensDoubles]: t('womens.doubles'),
  [mixedDoubles]: t('mixed.doubles'),
};

export const tournamentTypeMap: { [key: string]: { label: string; customName: string } } = {
  WTA500: { label: 'WTA 500', customName: 'WTA 500' },
  WTA250: { label: 'WTA 250', customName: 'WTA 250' },
  ATP250: { label: 'ATP 250', customName: 'ATP 250' },
  GrandSlam: { label: 'Grand Slam', customName: 'GrandSlam' },
  WTA1000: { label: 'WTA 1000', customName: 'WTA 1000' },
  ATP500: { label: 'ATP 500', customName: 'ATP 500' },
  Masters: { label: 'ATP 1000', customName: 'ATP Masters 1000' },
};
